import React from 'react';

import chestIcon from '../assets/img/service-icon-1.svg';
import chastLTAIcon from '../assets/img/service-icon-2.svg';
import cervicalIcon from '../assets/img/service-icon-3.svg';
import sholderIcon from '../assets/img/service-icon-4.svg';
import abdomenIcon from '../assets/img/service-icon-5.svg';
import wristIcon from '../assets/img/service-icon-6.svg';
import elbowIcon from '../assets/img/service-icon-7.svg';
import fingerIcon from '../assets/img/service-icon-8.svg';
import ankleIcon from '../assets/img/service-icon-9.svg';
import kneeIcon from '../assets/img/service-icon-10.svg';
import lumberIcon from '../assets/img/service-icon-11.svg';
import spineIcon from '../assets/img/service-icon-12.svg';
import hipIcon from '../assets/img/service-icon-13.svg';


const AllServices = () => {
    return (
        <section className="our-services">
            <div className="container c_container">
                <div className="row">
                    <div className="col-12">
                        <div className="ourServices_header text-center">
                            <h6 className="small-heading" data-aos="fade-up">
                                Popular Testigo Services
                            </h6>
                            <h3 className="heading-gradient" data-aos="fade-up">
                                Testigo Mobile Xray Services
                            </h3>
                        </div>
                        <div className="ourServices_body">
                            <div className="row justify-content-center">
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{1000}"
                                >
                                    <div className="ourService_box">
                                        <img src={chestIcon} alt="" />
                                        <p>Chest - PA</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{2000}"
                                >
                                    <div className="ourService_box">
                                        <img src={chastLTAIcon} alt="" />
                                        <p>Chest - LAT</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{3000}"
                                >
                                    <div className="ourService_box">
                                        <img src={cervicalIcon} alt="" />
                                        <p>Cervical Spine - AP</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{4000}"
                                >
                                    <div className="ourService_box">
                                        <img src={sholderIcon} alt="" />
                                        <p>Shoulder - AP</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{5000}"
                                >
                                    <div className="ourService_box">
                                        <img src={abdomenIcon} alt="" />
                                        <p>Abdomen / Kub Bladder / IVP - AP</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{6000}"
                                >
                                    <div className="ourService_box">
                                        <img src={wristIcon} alt="" />
                                        <p>Wrist - AP / LAT</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{7000}"
                                >
                                    <div className="ourService_box">
                                        <img src={elbowIcon} alt="" />
                                        <p>Elbow - AP / LAT</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{8000}"
                                >
                                    <div className="ourService_box">
                                        <img src={fingerIcon} alt="" />
                                        <p>Finger - AP</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{9000}"
                                >
                                    <div className="ourService_box">
                                        <img src={ankleIcon} alt="" />
                                        <p>Ankle - AP / LAT</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{10000}"
                                >
                                    <div className="ourService_box">
                                        <img src={kneeIcon} alt="" />
                                        <p>Knee - AP / LAT</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{11000}"
                                >
                                    <div className="ourService_box">
                                        <img src={lumberIcon} alt="" />
                                        <p>Lumber Spine - AP</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{12000}"
                                >
                                    <div className="ourService_box">
                                        <img src={spineIcon} alt="" />
                                        <p>Dorsolumber Spine - AP</p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-duration="{13000}"
                                >
                                    <div className="ourService_box">
                                        <img src={hipIcon} alt="" />
                                        <p>Pelvis with Both Hip - AP</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default AllServices;